module.exports = __webpack_public_path__ + "static/getthecorona-04f20e3d65117cb7af5a29d305e6d9a4.png";